import "./login-form.scss";

document.addEventListener("DOMContentLoaded", function () {
  // Ensure loginFormData is defined
  if (typeof loginFormData === "undefined") {
    console.error("loginFormData is not defined.");
    return;
  }

  const { signin_with_email_nonce, ajaxurl } = loginFormData;

  // Get the form elements

  const form = document.getElementById("signin-form");
  const emailInput = document.getElementById("email");
  const submitButton = document.getElementById("submit");
  const responseMessage = document.getElementById("response-message");

  // Add event listener for form submission
  form.addEventListener("submit", function (e) {
    e.preventDefault(); // Prevent default form submission

    console.log("Form submitted");
    // Disable the submit button to prevent multiple submissions
    submitButton.disabled = true;

    // Get the email value
    const email = emailInput.value;

    // clear response message
    responseMessage.textContent = "";

    // Perform the AJAX request to handle the signup
    jQuery.ajax({
      url: ajaxurl, // URL to send the request
      type: "POST",
      data: {
        action: "signin_with_email", // Action to trigger in PHP
        email: email,
        security: signin_with_email_nonce // Nonce for security
      },
      success: function (response) {
        if (response.success) {
          // add success class
          responseMessage.classList.add("success");
          // remove error class
          responseMessage.classList.remove("error");
          responseMessage.textContent = response.data.message;
          responseMessage.style.color = "green";
        } else {
          // add error class
          responseMessage.classList.add("error");
          // remove success class
          responseMessage.classList.remove("success");

          responseMessage.textContent = response.data.message;
          responseMessage.style.color = "red";
        }
        // Enable the submit button after response
        submitButton.disabled = false;
      },
      error: function (xhr, status, error) {
        // add error class
        responseMessage.classList.add("error");
        // remove success class
        responseMessage.classList.remove("success");
        responseMessage.textContent = "An error occurred. Please try again.";

        // Enable the submit button after response
        submitButton.disabled = false;
      }
    });
  });
});
